import { z } from 'zod';
import { Dateish } from './common';

export const VaultPermissionLevelSchema = z.enum(['read', 'write']);
export type VaultPermissionLevel = z.infer<typeof VaultPermissionLevelSchema>;

export const VaultSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  createdById: z.number().int().nullable(),
  /** meu nível efetivo (admins têm write em tudo) */
  myLevel: VaultPermissionLevelSchema,
  entryCount: z.number().int(),
});
export type Vault = z.infer<typeof VaultSchema>;

export const VaultPermissionSchema = z.object({
  userId: z.number().int(),
  userName: z.string(),
  level: VaultPermissionLevelSchema,
});
export type VaultPermission = z.infer<typeof VaultPermissionSchema>;

export const VaultBodySchema = z.object({
  name: z.string().min(1),
  permissions: z
    .array(z.object({ userId: z.number().int().positive(), level: VaultPermissionLevelSchema }))
    .default([]),
});
export type VaultBody = z.infer<typeof VaultBodySchema>;

export const VaultFolderSchema = z.object({
  id: z.number().int(),
  vaultId: z.number().int(),
  parentId: z.number().int().nullable(),
  name: z.string(),
});
export type VaultFolder = z.infer<typeof VaultFolderSchema>;

export const VaultFolderBodySchema = z.object({
  name: z.string().min(1),
  parentId: z.number().int().positive().nullish(),
});

/** Entrada SEM o segredo — listagens nunca carregam senha. */
export const VaultEntrySchema = z.object({
  id: z.number().int(),
  vaultId: z.number().int(),
  folderId: z.number().int().nullable(),
  name: z.string(),
  description: z.string().nullable(),
  username: z.string().nullable(),
  url: z.string().nullable(),
  ip: z.string().nullable(),
  clientId: z.number().int().nullable(),
  clientName: z.string().nullable(),
  updatedAt: Dateish,
});
export type VaultEntry = z.infer<typeof VaultEntrySchema>;

export const VaultEntryBodySchema = z.object({
  folderId: z.number().int().positive().nullish(),
  name: z.string().min(1),
  description: z.string().nullish(),
  username: z.string().nullish(),
  url: z.string().url().nullish(),
  ip: z.string().nullish(),
  clientId: z.number().int().positive().nullish(),
  /** obrigatório no create; opcional no update (mantém o atual) */
  secret: z.string().min(1).optional(),
});
export type VaultEntryBody = z.infer<typeof VaultEntryBodySchema>;

export const VaultTreeSchema = z.object({
  vault: VaultSchema,
  permissions: z.array(VaultPermissionSchema),
  folders: z.array(VaultFolderSchema),
  entries: z.array(VaultEntrySchema),
});
export type VaultTree = z.infer<typeof VaultTreeSchema>;

/** Único lugar onde o segredo cruza a rede — sempre auditado. */
export const VaultRevealResponseSchema = z.object({ secret: z.string() });

export const VaultLogSchema = z.object({
  id: z.number().int(),
  entryId: z.number().int().nullable(),
  entryName: z.string(),
  userName: z.string().nullable(),
  action: z.enum(['created', 'updated', 'revealed', 'deleted']),
  createdAt: Dateish,
});
export type VaultLog = z.infer<typeof VaultLogSchema>;
